import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../../cfet-core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customer-instant-verification-utf',
    templateUrl: './customer-instant-verification-utf.component.html',
    styleUrls: ['./customer-instant-verification-utf.component.scss'],
    standalone: false
})
export class CustomerInstantVerificationUtfComponent extends CfetBaseComponent implements OnInit {

  @Output() clearTimeout = new EventEmitter<any>(false);
  @Output() showCancelModal = new EventEmitter<any>();

  constructor(private router: Router) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  continueToProfileInfo(event) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      this.clearTimeout.emit(true);
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PROFILE_UTF]);
    }
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.keyCode === 13 || event.type === 'click') {
      this.showCancelModal.emit(true);
    }
  }

}
